// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".left-margin[data-v-3ca09d2e]{margin-left:12px}.top-margin[data-v-3ca09d2e]{margin-top:24px}.side-margin[data-v-3ca09d2e]{margin-left:6px;margin-right:6px}.dc--has-tooltip[data-v-3ca09d2e]:after{white-space:normal;width:320px;text-align:justify;font-size:12px;line-height:16px}", ""]);
// Exports
module.exports = exports;
